(function () {

    "use strict";

    angular
        .module("harriApp")
        .component("candidateNotesComponent", {
            controller: candidateNotesComponent,
            bindings: {
                sourceBrand: "<?",
                activeBrand: "<",
                memberId: "<",
                inToolBox: "<",
                addNotesOnly: "<",
                onNoteAdded: "&",
                disablePermissionsNotification: "<"
            },
            controllerAs: '$ctrl',
            templateUrl: '../modules/speedy_screen/components/candidate-notes/candidate-notes.component.ng.html'
        });

    /*
    activeBrand // not child
    {
        id: 123,
        name: "brand name", // optional
        isGP: true/false, // or type
        type: "GP-1" // or isGP
    }

    sourceBrand
    {
        id: 123,
        name: "brand name" // optional
    }
     */

    candidateNotesComponent.$inject = ['$scope', 'candidateNotesService', 'userPermissions', 'hUser', '$q'];

    function candidateNotesComponent($scope, candidateNotesService, userPermissions, hUser, $q) {

        var self = this;
        self.originalNotes = [];
        var activeBrand, sourceBrand;
        self.hasManageNotesPermission = true;

        var getBrandId = function () {
            return (activeBrand && activeBrand.id) || (sourceBrand && sourceBrand.id)
        };

        var onNoteAddedHandler = function (notes) {
            notes = notes || [];
            self.originalNotes = notes.concat(self.originalNotes || []);
            prepareFilters(self.originalNotes);
            prepareAddedByLocationList(self.originalNotes);
            resetFilters();
            self.data = {};
        };

        self.isGPBrand = function (brandType) {
            return brandType.indexOf("GP-") === 0;
        };

        self.filtersChanged = function () {
            var notesToShow = self.originalNotes;
            if (self.filters) {
                if (self.filters.location) {
                    notesToShow = _.filter(notesToShow, function (comment) {
                        return comment.brand.id === self.filters.location.id;
                    }) || [];
                }

                if (self.filters.manager) {
                    notesToShow = _.filter(notesToShow, function (comment) {
                        return comment.added_by_user.id === self.filters.manager.id;
                    }) || [];
                }
            }
            self.notes = notesToShow;
        };

        self.addNote = function () {
            if (self.membersIds && self.membersIds.length && self.hasManageNotesPermission && self.data.location && self.data.note && self.data.note !== "") {
                self.addingNote = true;

                var params = {
                    comment: self.data.note,
                    candidate_ids: self.membersIds
                };
                candidateNotesService
                    .createCandidateNote(self.data.location.id, params)
                    .then(function (notes) {
                        self.addingNote = false;

                        HNotifications.show({
                            title: $filter("translate")("Your note has been successfully saved"),
                            icon: "fa-check-circle",
                            type: "success",
                            timeout: 3000
                        });

                        self.onNoteAdded({note: self.data.note});

                    }, function (err) {
                        console.error(err);
                        self.addingNote = false;
                    });
            }
        };

        var resetFilters = function () {
            self.filters = {};
            self.filtersChanged();
        };

        var prepareFilters = function (notes) {
            var managers = [];
            var locations = [];
            for (var i in notes) {
                var found = _.find(locations, {id: notes[i].brand.id});
                if (!found) {
                    locations.push(notes[i].brand);
                }


                var found = _.find(managers, {id: notes[i].added_by_user.id});
                if (!found) {
                    notes[i].added_by_user.full_name = notes[i].added_by_user.first_name + " " + notes[i].added_by_user.last_name;
                    managers.push(notes[i].added_by_user);
                }
            }
            self.managers = managers;
            self.locations = locations;
        };

        var pushToAddedByLocationList = function (location) {
            var found = _.find(self.addedByLocations, {"id": location.id});
            if (!found) {
                self.addedByLocations.push({
                    id: location.id,
                    type: location.type,
                    name: location.name
                });
            }
            self.data.location = self.addedByLocations[0];
        };

        var hasManageNotesPermissions = function (brandsIds) {
            var deferred = $q.defer();
            brandsIds = angular.isArray(brandsIds)? brandsIds: [brandsIds];

            userPermissions.getBrandPolicy(brandsIds)
                .then(function (policyParser) {
                    var hasPermission = false;
                    for (var i in brandsIds) {
                        hasPermission = hasPermission || policyParser.clone().brand(brandsIds[i]).has(userPermissions.PERMISSIONS.MANAGE_CANDIDATE_NOTES);
                    }
                    deferred.resolve(hasPermission);
                }, function (err) {
                    console.error(err);
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        var prepareAddedByLocationList = function (notes) {
            var deferred = $q.defer();

            self.addedByLocations = [];
            var permissionPromises = {};

            for (var i in notes) {
                permissionPromises[notes[i].brand.id] = hasManageNotesPermissions(notes[i].brand.id);
            }

            if (sourceBrand && activeBrand.id !== sourceBrand.id) {
                permissionPromises[sourceBrand.id] = hasManageNotesPermissions(sourceBrand.id);
            }

            if (activeBrand) {
                if (activeBrand.isGP || (activeBrand.type && self.isGPBrand(activeBrand.type))) {
                    permissionPromises[activeBrand.id] = hasManageNotesPermissions(activeBrand.id);
                } else {
                    var brandsListIds = _.pluck(hUser.getUser().brands_list, "id");
                    permissionPromises[activeBrand.id] = hasManageNotesPermissions(brandsListIds);
                }
            }

            $q.all(permissionPromises)
                .then(function (res) {
                    if (res[activeBrand.id]) {
                        pushToAddedByLocationList(activeBrand);
                    }
                    for (var i in notes) {
                        if (res[notes[i].brand.id]) {
                            pushToAddedByLocationList(notes[i].brand);
                        }
                    }
                    if (sourceBrand && res[sourceBrand.id]) {
                        pushToAddedByLocationList(sourceBrand);
                    }
                    deferred.resolve();
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        var prepareBrandsData = function () {
            var deferred = $q.defer();

            var brandsDataPromises = {};
            if (sourceBrand && activeBrand.id !== sourceBrand.id && (!sourceBrand.name || sourceBrand.name === '')) {
                brandsDataPromises[sourceBrand.id] = candidateNotesService.getBrandBasicInfo(sourceBrand.id);
            }

            if (activeBrand && (!activeBrand.name || activeBrand.name === '')) {
                brandsDataPromises[activeBrand.id] = candidateNotesService.getBrandBasicInfo(activeBrand.id);
            }

            $q.all(brandsDataPromises)
                .then(function (res) {
                    if (sourceBrand && res[sourceBrand.id]) {
                        sourceBrand = res[sourceBrand.id];
                    }

                    if (activeBrand && res[activeBrand.id]) {
                        activeBrand = res[activeBrand.id];
                    }
                    deferred.resolve();
                })
                .catch(function (err) {
                    deferred.reject(err);
                });
            return deferred.promise;
        };

        var init = function () {
            self.loading = true;
            self.additionalClass = (self.inToolBox && "in-tool-box") || "";
            self.filters = {};
            self.data = {};
            self.addingNote = false;
            activeBrand = self.activeBrand;
            sourceBrand = self.sourceBrand;
            if (activeBrand) {
                activeBrand.id = parseInt(activeBrand.id);
            }
            if (sourceBrand) {
                sourceBrand.id = parseInt(sourceBrand.id);
            }

            var promises = {};

            if (!self.addNotesOnly) {
                promises['notes'] = candidateNotesService.getCandidateNotes(getBrandId(), self.membersIds[0])
            }

            $q.all(promises)
                .then(function (res) {
                    if (!res['notes'] || (res['notes'] && typeof (res['notes']) == "string")) {
                        res['notes'] = [];
                    }
                    self.notes = angular.copy(res['notes']);
                    self.originalNotes = angular.copy(res['notes']);
                    prepareFilters(res['notes']);
                    prepareBrandsData()
                        .then(function () {
                            prepareAddedByLocationList(res['notes'])
                                .then(function () {
                                    self.hasManageNotesPermission = !!self.addedByLocations.length;
                                    if (!self.disablePermissionsNotification && !self.hasManageNotesPermission && self.addNotesOnly) {
                                        HNotifications.show({
                                            title: $filter("translate")("You don't have enough permissions"),
                                            icon: "fa-times-circle",
                                            type: "danger",
                                            timeout: 3000
                                        });
                                    }
                                    self.loading = false;
                                }, function (err) {
                                    console.error(err);
                                    self.loading = false;
                                });
                        });
                }, function (err) {
                    console.error(err);
                    self.loading = false;
                });
        };

        var onNoteAddedEvent = candidateNotesService.on(candidateNotesService.EVENTS.ON_NOTE_CREATED, onNoteAddedHandler);

        self.$onInit = function () {
            init();
        };

        self.$onChanges = function (changesObj) {
            if (changesObj.memberId && changesObj.memberId.currentValue !== changesObj.memberId.previousValue) {
                self.membersIds = angular.isArray(self.memberId) ? self.memberId : [self.memberId];
            }
        };

        self.$onDestroy = function () {
            candidateNotesService.off(onNoteAddedEvent);
        };
    }
})();
